import { render, staticRenderFns } from "./Usp_Rep_AT12_Comparacion.vue?vue&type=template&id=746bc16e"
import script from "./Usp_Rep_AT12_Comparacion.vue?vue&type=script&lang=js"
export * from "./Usp_Rep_AT12_Comparacion.vue?vue&type=script&lang=js"
import style0 from "./Usp_Rep_AT12_Comparacion.vue?vue&type=style&index=0&id=746bc16e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports